import React from "react";
import { useParams, Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function BlogDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setError("Article not found."));
  }, [slug]);

  if (error)
    return (
      <div className="mfb-container py-32 text-center">
        <div className="text-slate-400" data-testid="blog-not-found">{error}</div>
        <Link to="/blog" className="text-sky-400 mt-4 inline-block">Back to blog</Link>
      </div>
    );

  if (!post) return <div className="mfb-container py-32 text-slate-400">Loading…</div>;

  return (
    <article className="py-20" data-testid="blog-detail">
      <div className="mfb-container max-w-3xl">
        <Link to="/blog" className="text-sm text-slate-400 hover:text-white inline-flex items-center gap-1 mb-8">
          <ArrowLeft className="w-3.5 h-3.5" /> All articles
        </Link>
        <Badge className="bg-sky-500/10 text-sky-300 border-sky-500/20 hover:bg-sky-500/15">{post.category}</Badge>
        <h1 className="mt-5 font-[Outfit] text-4xl sm:text-5xl font-light tracking-tight text-white leading-tight">
          {post.title}
        </h1>
        <div className="mt-4 flex items-center gap-3 text-slate-500 text-sm">
          <span>{post.author}</span>
          <span>·</span>
          <span>{new Date(post.created_at).toLocaleDateString()}</span>
        </div>
        {post.cover_image && (
          <img src={post.cover_image} alt={post.title} className="mt-10 rounded-2xl w-full object-cover aspect-[16/9]" />
        )}
        <div className="mt-10 prose prose-invert max-w-none text-slate-300 leading-relaxed whitespace-pre-line text-base">
          {post.content}
        </div>
      </div>
    </article>
  );
}
